import { render, staticRenderFns } from "./WhiteLabelSettings.vue?vue&type=template&id=a0282abc&scoped=true"
import script from "./WhiteLabelSettings.vue?vue&type=script&lang=js"
export * from "./WhiteLabelSettings.vue?vue&type=script&lang=js"
import style0 from "./WhiteLabelSettings.vue?vue&type=style&index=0&id=a0282abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0282abc",
  null
  
)

export default component.exports